<div class="flex w-full flex-row gap-2">
    <div class="flex-grow">
        <canvas #pieChartCanvasRef></canvas>
    </div>
    <div class="flex-grow">
        <canvas #barChartCanvasRef></canvas>
    </div>
</div>
